import React from 'react';

export const WarningNotificationBanner = ({ message, children }) => {
  return <div className='notification-banner notification-banner--warning'>
    <div className='notification-banner__container'>
      <div className='notification-banner__body'>
        <span className='notification-banner__title'>ALERT: </span>
        <span className='notification-banner__message'>{message}</span>
        { children && <div className='notification-banner__more-info'>{children}</div> }
      </div>
    </div>
  </div>
};


